<template>
  <div id="contenedor-editar-status-contrato">
    <v-form ref="editarContratoEstatus" v-model="esFormularioValido">
      <v-card>
        <v-card-title class="secondary--text">
          Editar estatus de contrato
          <v-spacer></v-spacer>
          <v-btn icon @click="cerrar">
            <v-icon class="secondary--text" large>highlight_off</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <custom-text-field
            label="Nombre"
            v-model="estatus.nombre"
            :rules="[mixReglas.requerido]"
            required
          >
          </custom-text-field>
          <v-label>Color</v-label>
          <v-menu
            v-model="menu"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-avatar
                class="ma-2"
                size="40"
                :color="estatus.color"
                readonly
                v-bind="attrs"
                v-on="on"
              >
              </v-avatar>
            </template>
            <v-color-picker
              v-model="estatus.color"
              mode="hexa"
              hide-canvas
              hide-inputs
              hide-mode-switch
              hide-sliders
              show-swatches
              swatches-max-height="200"
            >
            </v-color-picker>
          </v-menu>
          <v-switch
            v-model="estatus.esTextoClaro"
            label="¿Texto Blanco?"
            inset
          >
          </v-switch>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <custom-button
            @click="cerrar"
            tipo="formCancelar"
            label="Cancelar"
            class="mr-3">
          </custom-button>
          <custom-button
            @click="mixActualizarContratoEstatus"
            :disabled="!esFormularioValido || enviandoFormulario"
            :loading="enviandoFormulario"
            tipo="formAceptar"
            label="Actualizar">
          </custom-button>
        </v-card-actions>
      </v-card>
    </v-form>
  </div>
</template>

<script>
import mixContratoEstatus from './mixContratoEstatus';
import CustomTextField from '@/components/inputs/TextField.vue';
import CustomButton from '@/components/buttons/Button.vue';

export default {
  name: 'CatalogosContratoEstatusEditar',
  mixins: [mixContratoEstatus],
  props: {
    contratoEstatusEditar: {
      typeo: Object,
      required: true,
    },
  },
  components: {
    CustomTextField,
    CustomButton,
  },
  data() {
    return {
      esFormularioValido: false,
      enviandoFormulario: false,
      estatus: {
        nombre: this.contratoEstatusEditar.nombre,
        color: this.contratoEstatusEditar.color,
        esTextoClaro: this.contratoEstatusEditar.esTextoClaro,
      },
      menu: false,
    };
  },
  methods: {
    cerrar() {
      this.limpiarFormulario();
      this.$emit('cerrar');
    },
    limpiarFormulario() {
      this.$refs.editarContratoEstatus.reset();
    },
  },
};
</script>

<style>
</style>
